import React from "react";
import { Doughnut } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
// Certifique-se de registrar o plugin no Chart.js
import { Chart as ChartJS } from "chart.js";
ChartJS.register(ChartDataLabels);
var DonutChart = function (_a) {
    var results = _a.results, fields = _a.fields, _b = _a.height, height = _b === void 0 ? 220 : _b, backgroundColor = _a.backgroundColor;
    var labels = Object.keys(results);
    var field = fields[0]; // normalmente só um campo por gráfico
    var dataValues = labels.map(function (label) { var _a; return (_a = results[label][field.key]) !== null && _a !== void 0 ? _a : 0; });
    // Use a prop backgroundColor se existir, senão use as cores padrão
    var defaultColors = ["#3b82f6", "#a78bfa", "#22d3ee", "#818cf8", "#94a3b8"];
    var bgColors = backgroundColor && backgroundColor.length === labels.length
        ? backgroundColor
        : labels.map(function (_, i) { return defaultColors[i % defaultColors.length]; });
    var data = {
        labels: labels,
        datasets: [
            {
                label: field.label,
                data: dataValues,
                backgroundColor: bgColors,
                borderColor: "#222",
                borderWidth: 2,
            },
        ],
    };
    return (React.createElement("div", { style: { height: height, width: "100%" } },
        React.createElement(Doughnut, { data: data, options: {
                plugins: {
                    legend: { labels: { color: "#fff" } },
                    datalabels: {
                        color: "#fff",
                        font: { weight: "bold" },
                        formatter: function (value, context) {
                            var total = context.chart.data.datasets[0].data.reduce(function (a, b) { return a + b; }, 0);
                            if (!total)
                                return "0%";
                            var percent = ((value / total) * 100).toFixed(1);
                            return "".concat(percent, "%");
                        },
                    },
                },
                maintainAspectRatio: false,
                responsive: true,
            }, plugins: [ChartDataLabels], height: height })));
};
export default DonutChart;
